/**
 * Auto-generated Zod schema for RepositoryVulnerabilityAlertResolveEvent
 * DO NOT MODIFY - regenerate with: bun run generate:schemas
 */

import type { RepositoryVulnerabilityAlertResolveEvent as RepositoryVulnerabilityAlertResolveEventOctokit } from '@octokit/webhooks-types';
import { z } from 'zod';

import {
  GitHubOrgSchema,
  OrganizationSchema,
  RepositorySchema,
  RepositoryVulnerabilityAlertAlertSchema,
} from './shared/index.js';

export const RepositoryVulnerabilityAlertResolveEventSchema = z.object({
  action: z.literal('resolve'),
  alert: RepositoryVulnerabilityAlertAlertSchema.and(
    z.object({
      state: z.literal('fixed'),
      fixed_at: z.string(),
      fix_reason: z.string(),
      fixed_in: z.string(),
    }),
  ),
  repository: RepositorySchema,
  sender: GitHubOrgSchema,
  organization: OrganizationSchema.optional(),
}) satisfies z.ZodType<RepositoryVulnerabilityAlertResolveEventOctokit>;

export type RepositoryVulnerabilityAlertResolveEvent =
  RepositoryVulnerabilityAlertResolveEventOctokit;

export function isRepositoryVulnerabilityAlertResolveEvent(
  value: unknown,
): value is RepositoryVulnerabilityAlertResolveEvent {
  return RepositoryVulnerabilityAlertResolveEventSchema.safeParse(value).success;
}
